<template>
    <div id="mdkt2018" class='activity-panel'>
        <div class='background-panel'>
            <span class='background-wrapper' data-index='1'></span>
            <span class='background-wrapper' data-index='2'></span>
            <span class='background-wrapper' data-index='3'></span>
        </div>
        <headerBar></headerBar>
        <template v-if="($route.name != 'comment' && $route.name != 'score')">
            <qrcode></qrcode>
            <share></share>
        </template>
    
        
        <videoPlayer ></videoPlayer>
        
        <div class='main-panel'> 
            <div class="nav-panel">
                <router-link to="/home" class='nav-item' data-index='home'></router-link>
                <router-link to="/rule" class='nav-item' data-index='rule'></router-link>
                <router-link to="/work" class='nav-item' data-index='work'></router-link>
                <router-link to="/winner" class='nav-item' data-index='winner'></router-link>
            </div>
            <div class='page-panel'>
                <router-view ></router-view>
            </div>
            
        </div>
    </div>
</template>

<script>
//视频组件
import videoPlayer from '@/components/video-players'
import navBar from '@/components/nav-bar'
import headerBar from '@/components/header-bar'
import share from '@/components/share'
import qrcode from '@/components/qrcode'
export default {
    name: 'mdkt2018',
    data() {
        return {
        }
    },
    components: {
        videoPlayer,
        navBar,
        headerBar,
        share,
        qrcode
    },
    created () {
        // captcha1 = new TencentCaptcha('2046911983', function(res) {
        //     alert(res);
        // });
    }
}
</script>

<style rel="stylesheet/scss" lang="scss">
/*class命名规则
区块名-panel     板块
区块名-warpper   外围
区块名-title     标题
区块名-body      主体
区块名-cnt       内容
区块名-item      项
*/

@import "/assets/sass/cmn.scss";
body,ul,p,h1,a,dl,dd {
    padding: 0;
    margin: 0;
    list-style-type:none;
    text-decoration: none;
}
a{
    outline: none; 
}
body {
    min-width: 1370px;
    font-size: 16px;
    //background-color: #542eab;
    background:  url(imgPath('bg.jpg')) center top;
    font-family: "Microsoft Yahei", Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
}
input, textarea {
    outline: none;
    font-family: 'Microsoft Yahei',Helvetica,Arial,sans-serif;
}
input::-webkit-input-placeholder{
    color:#ab92e4;
}
input::-moz-placeholder{   /* Mozilla Firefox 19+ */
    color:#ab92e4;
}
input:-ms-input-placeholder{  /* Internet Explorer 10-11 */ 
    color:#ab92e4;
}
//编号
.num{
    display: inline-block;
    width:18px;
    height:18px;
    line-height:18px;
    margin-right: 8px;
    color:#542eab;
    text-align: center;
    font-size: 12px;
    background:  url(imgPath('index/num.png')) center top no-repeat;
    vertical-align: middle;
}

//背景
.background-panel {
    padding-top: 60px;
    .background-wrapper {
        display: block;
        background-position: top center;
        background-repeat: no-repeat;
    }
    .background-wrapper[data-index="1"] {
        width: 100%;
        height: 400px;
        background-image: url(imgPath('bg_1.jpg'));
    }
    .background-wrapper[data-index="2"] {
        width: 100%;
        height: 400px;
        background-image: url(imgPath('bg_2.jpg'));
    }
    .background-wrapper[data-index="3"] {
        width: 100%;
        height: 365px;
        background-image: url(imgPath('bg_3.jpg'));
    }
}
.page-panel{
    width: 100%;
    padding-top: 40px;
    padding-bottom: 200px;
    background: url(imgPath('bg-bt1.jpg'))  bottom center no-repeat;
}
//导航条
.nav-panel{
    position: relative;
    margin-top: -85px;
    font-size: 0;
    text-align: center;
    z-index: 100;
    .nav-item{
        display: inline-block;
        width: 290px;
        height: 100px;
        background-repeat: no-repeat;
    }
    .nav-item[data-index="home"] {
        background-image: url(imgPath('nav/nav1.png'));
    }
    .nav-item[data-index="rule"] {
        background-image: url(imgPath('nav/nav2.png'));
    }
    .nav-item[data-index="work"] {
        background-image: url(imgPath('nav/nav3.png'));
    }
    .nav-item[data-index="winner"] {
        background-image: url(imgPath('nav/nav4.png'));
    }
    .router-link-active[data-index="home"] {
        background-image: url(imgPath('nav/nav-select1.png'));
    }
    .router-link-active[data-index="rule"] {
        background-image: url(imgPath('nav/nav-select2.png'));
    }
    .router-link-active[data-index="work"] {
        background-image: url(imgPath('nav/nav-select3.png'));
    }
    .router-link-active[data-index="winner"] {
        background-image: url(imgPath('nav/nav-select4.png'));
    }
}
//内容
.key-txt{
    color: #7be5ff;
}
.part-panel{
    width: 1010px;
    margin: 0 auto 100px;
    .part-txt{
        line-height: 2;
    }
    .self-bg{
        position: relative;
        width: 986px;
        //margin: 0 auto;
        padding: 30px 20px 30px 40px;
        color: #fff;
        border: 2px solid #e1d5f4;
        border-top: 0;
        z-index: 10;
        box-sizing: border-box;
        
        &:before{
            content: '';
            display: block;
            width: 100%;
            height: calc(100% + 20px);
            position: absolute;
            top: 0;
            left:20px;
            z-index: -1;
            background-color: rgba(255,255,255,.2);
        }
    }
    .part-title{
        height: 48px;
        background-position: top left;
        background-repeat: no-repeat;
    }
    .part-warpper[data-index="sponsor"]{
        text-align: center;
        .part-body{
            margin-bottom: 50px;
        }
        .part-title{
            margin-bottom: 20px;
            background-position: top center;
        }
        .part-item {
            display: inline-block;
            outline: none; 
        }
        div[data-index="1"]{
            .part-title{
                background-image: url(imgPath('index/title-s.png'));
            }
            .part-item {
                width: 310px;
                height: 55px;
                background-image: url(imgPath('index/sponsor-1.png'));
                background-repeat: no-repeat;
                cursor: default;
                vertical-align: middle;
            }
            .md{
                background-position: center 0;
            }
            .kugou{
                background-position:  center -85px;
            }
            .sing{
                background-position:  center -184px;
            }
        }
        div[data-index="2"]{
            .part-title{
                background-image: url(imgPath('index/title-x.png'));
            }
            .part-item {
                width: 158px;
                height: 32px;
                background-image: url(imgPath('index/sponsor-2.png'));
                background-repeat: no-repeat;
                cursor: default;
            }
        }
        div[data-index="3"]{
            .part-title{
                background-image: url(imgPath('index/title-zc.png'));
            }
            .part-item {
                width: 135px;
                height: 50px;
                margin: 0 20px 18px 20px;
                background-image: url(imgPath('index/sponsor-3.png'));
                background-repeat: no-repeat;
                cursor: default;
            }
            .za{
                background-position: 0 0;
            }
            .yd{
                background-position: -152px 0;
            }
            .grt{
                background-position: 0 -65px
            }
            .sy{
                background-position: -152px -65px
            }
            .txt{
                color: #e2def0;
                font-size: 16px;
            }
        }
    }
}
.no-data{
    height: 600px;
    background: url(imgPath('index/41.png')) center no-repeat;
}
.no-search{
    height: 600px;
    line-height: 600px;
    text-align: center;
}
//自定义调整
.activity-panel{
    position: relative;
    //视频
    .videoplayer-panel{
        position: absolute;
        top: 560px;
        left: 50%;
        -webkit-transform:  translateX(-50%);
        -moz-transform:  translateX(-50%);
        -ms-transform:  translateX(-50%);
        -o-transform: translateX(-50%);
        transform: translateX(-50%);
    }
    
}

</style>



// WEBPACK FOOTER //
// src/App.vue